import { IMessage } from '@interfaces/iMessage'
import { ICompleteFile } from '@interfaces/realEstateFiles/iCompleteFile'
import { IRealEstateFile } from '@interfaces/realEstateFiles/iRealEstateFile'
import api from '@services/api/server'

export default class RealEstateFileService {
    public static async create(values: FormData, realEstateId: number): Promise<IRealEstateFile> {
        return (await api.post<IRealEstateFile>(`/real-estates/${realEstateId}/files`, values)).data
    }

    public static async list(realEstateId: number, type: string): Promise<ICompleteFile[]> {
        return (await api.get<ICompleteFile[]>(`/real-estates/${realEstateId}/files/list?type=${type}`)).data
    }

    public static async remove(fileId: number, realEstateId: number): Promise<IMessage> {
        return (await api.delete<IMessage>(`/real-estates/${realEstateId}/files/${fileId}`)).data
    }

    public static async setCover(fileId: number, realEstateId: number): Promise<IMessage> {
        return (await api.patch<IMessage>(`/real-estates/${realEstateId}/files/${fileId}/cover-update`)).data
    }
}
